import { Chip, SelectButton, ToggleButton } from 'primereact';
import React,{ useState } from 'react';
export function Top5Cxp() {
  const [value, setValue] = useState(null);
  const items = [
    { name: "30 días", value: 1 },
    { name: "60 días", value: 2 },
    { name: "90 días", value: 3 },
    { name: "+90 días", value: 4 },
  ];

  function handleChange(value) {
    setValue(value);
    if (value === 1) {
      setTableTop5Cxp(cxp_respuesta30);
      tableTop5Cxp.show();
    } else if (value === 2) {
      setTableTop5Cxp(cxp_respuesta60);
      tableTop5Cxp.show();
    } else if (value === 3) {
      setTableTop5Cxp(cxp_respuesta90);
      tableTop5Cxp.show();
    } else if (value === 4) {
      setTableTop5Cxp(cxp_respuestaMas90);
      tableTop5Cxp.show();
    } else {
      tableTop5Cxp.hide();
    }
  }

  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectButton
          value={value}
          onChange={(e) => handleChange(e.value)}
          optionLabel="name"
          options={items}
        />
      </div>
    </React.Fragment>
  );
}